export default function PreviewCustomTemplate() {
  return (
    <div className="w-full mt-6 p-4 bg-lightGray rounded-lg h-[calc(100%-1.5rem)] flex flex-col justify-center">
      <p className="text-center">Preview unavailable for custom templates.</p>
    </div>
  );
}
